﻿define(
({
	loadingState: "लोड किया जा रहा है...",
	errorState: "क्षमा करें, कोई त्रुटि आई"
})
);
